import React from 'react';

const ApprovedStamp = () => {
  return (
    <p
      className="tc rotate"
      style={{
        fontSize: '32px',
        fontWeight: 'bold',
        color: 'blue',
        fontFamily: 'arial',
      }}
    >
      APPROVED!
    </p>
  );
};

export default ApprovedStamp;
